import { Checkbox } from 'semantic-ui-react';
import React, { Component } from 'react';
import { Loader, Dimmer, Button } from 'semantic-ui-react';

class CheckboxList extends Component {
  constructor(props) {
    super(props);
    if (window[props.role] == null) window[props.role] = [];
    this.state = {
      checkedState: {}
    };
  }

  handleCheckboxChange = (item_label, checked) => {
    if (checked === true && window[this.props.role].indexOf(item_label) === -1)
      window[this.props.role].push(item_label);
    else
      window[this.props.role] = window[this.props.role].filter(item => item !== item_label);

    this.setState(prevState => ({
      checkedState: {
        ...prevState.checkedState,
        [item_label]: checked
      }
    }));
    this.props.setChartLoading(true);
    if (typeof gtag === "function")
      gtag('event', item_label, { 'event_category': 'NGSpice', 'event_label': this.props.role });

    // Explicitly trigger sync AND simulation on user change
    this.updateSelectedNodes(false, false);
  };

  getSelectedCheckboxes = () => {
    const selected = {};
    for (const key in this.state.checkedState) {
      if (this.state.checkedState[key] === true) {
        selected[key] = this.state.checkedState[key];
      }
    }
    return selected;
  };

  componentDidMount() {
    // On initial mount, update engine and trigger simulation (restore original behavior)
    this.updateSelectedNodes(false, false);
  }

  componentDidUpdate(prevProps, prevState) {
    // Removed automatic updateSelectedNodes on state change to avoid loops/race conditions
    // as handleCheckboxChange now calls it directly.
  }

  updateSelectedNodes = (skipSimulate = true, skipEngine = true) => {
    const { initialSelectedLabels, setSelectedNodes, role, nodes } = this.props;
    if (initialSelectedLabels == null) return;

    const labels = [1, 2, 3];
    let datasets = [];

    let selected = [];

    for (const key in window[this.props.role])
      if (selected.indexOf(window[this.props.role][key]) === -1) {

        // Find the node item to get its css_color
        const nodeItem = nodes.find(n => n.label === window[this.props.role][key] && n.role === role);
        const lineColor = nodeItem?.css_color || 'rgb(255, 99, 132)';

        selected.push(window[this.props.role][key]);
        datasets.push({
          label: window[this.props.role][key],
          data: [],
          borderColor: lineColor,
          backgroundColor: lineColor,
        });
      }

    setSelectedNodes({
      labels,
      datasets
    });

    if (!skipEngine) {
      com.clientside.main.Html5Bootstrap.jsCall("setSelectedNodesNums", selected, role);
    }

    if (!skipSimulate) {
      this.onSimulate();
    }
  };

  onSimulate = () => {
    com.clientside.main.Html5Bootstrap.jsCall("simulate");
  };

  onRefresh = () => {
    com.clientside.main.Html5Bootstrap.jsCall("refresh");
  };

  render() {
    const { top, label, role, nodes, isChartLoading } = this.props;
    const { checkedState } = this.state;
    const isMobile = this.props.isMobile !== undefined ? this.props.isMobile : (window.innerWidth <= 768);

    return (
      <>
        {isChartLoading ? (
          <div style={{ padding: 8 }}>{l.loading} ...</div>
        ) : (
          <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'row' : 'column',
            flexWrap: 'wrap',
            alignItems: isMobile ? 'center' : 'stretch',
            gap: isMobile ? '8px' : '0px'
          }}>
            <p style={{
              marginTop: isMobile ? 0 : top,
              textAlign: isMobile ? 'left' : 'center',
              color: 'inherit',
              paddingBottom: isMobile ? '0px' : '0px',
              paddingTop: '0px',
              fontWeight: isMobile ? 'bold' : 'normal',
              whiteSpace: 'nowrap',
              marginRight: isMobile ? '5px' : '0px',
              fontSize: isMobile ? '12px' : 'inherit'
            }}>
              {label}:
            </p>

            <div style={{
              display: 'flex',
              flexDirection: isMobile ? 'row' : 'column',
              flexWrap: isMobile ? 'wrap' : 'nowrap',
              gap: isMobile ? '6px' : '0px'
            }}>
              {nodes.map((item, index) => {
                if (item.role !== role) {
                  return null;
                }

                return (
                  <div key={index} style={{ padding: isMobile ? '0' : '4px 0', minHeight: isMobile ? '28px' : '32px', display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      key={item.label}
                      label={
                        <label style={{
                          fontFamily: 'monospace',
                          color: item.css_color,
                          paddingLeft: '6px', // Compact padding
                          paddingRight: isMobile ? '6px' : '0', // Space for wrapping
                          cursor: 'pointer',
                          userSelect: 'none',
                          fontSize: isMobile ? '12px' : 'inherit'
                        }}>
                          {window.thumbs.getDataLabel(item.label, role, item.metric_type)}
                        </label>
                      }
                      checked={window[role].indexOf(item.label) > -1}
                      onChange={(e, data) => this.handleCheckboxChange(item.label, data.checked)}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </>
    );
  }
}

export default CheckboxList;
